import { cn } from "@/lib/utils";
import { ChevronLeft, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function BackHeader({
  title,
  onClose,
  onBack,
}: {
  title?: string;
  onClose?: () => void;
  onBack?: () => void;
}) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-background z-10 flex gap-2 px-6 py-4 border-b-2 border-border items-center">
      <ChevronLeft onClick={handleGoBack} className="size-6 -ml-1 cursor-pointer" />
      <div
        className={cn(
          "flex flex-1 items-center justify-center",
          onClose ? "" : "pr-8"
        )}
      >
        <h1 className="font-medium text-left break-keep whitespace-pre-wrap">
          {title}
        </h1>
      </div>
      {onClose && <X onClick={onClose} className="size-6 cursor-pointer" />}
    </header>
  );
}
